module.exports = __webpack_public_path__ + "img/flower1.71ec6ddd.png";